import React, { useContext } from "react";
import "./RedirectPage.scss";
import AppContext from "../../config/AppContext";
import { useTranslation } from "react-i18next";

const RedirectPage = () => {
    const { t } = useTranslation();
    const { mode } = useContext(AppContext);
    return (
        <div className="redirect-background"
         style={{
            backgroundColor:mode=="dark"?"#121212":"#FFFFFF"
         }}
        >
            <div className="payment-loading">
                <span className={mode === "dark" ? "loading-textDark" : "loading-text"}>{t("RAL0929")}</span>
                <div className={mode === "dark" ? "loading-dotsDark" : "loading-dots"}>
                    <span></span>
                    <span></span>
                    <span></span>
                </div>
            </div>
        </div>

    );
};

export default RedirectPage;
